"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSelectHandlers = void 0;
var _react = require("react");
var useSelectHandlers = function useSelectHandlers(options, setSerchTermValue, onChange) {
  var handleSelect = (0, _react.useCallback)(function (label) {
    var newSelectedOption = options.find(function (o) {
      return o.label.text === label;
    });
    setSerchTermValue(newSelectedOption.label.text);
    onChange({
      currentTarget: {
        value: newSelectedOption.value
      }
    });
  }, [onChange, options, setSerchTermValue]);
  var handleClear = (0, _react.useCallback)(function () {
    onChange({
      currentTarget: {
        value: undefined
      }
    });
    setSerchTermValue('');
  }, [onChange, setSerchTermValue]);
  return {
    handleSelect: handleSelect,
    handleClear: handleClear
  };
};
exports.useSelectHandlers = useSelectHandlers;